export default __webpack_public_path__ + "static/media/Kanipakam-slider-03@2x.b1ec1436.png";